import { render, staticRenderFns } from "./OrganizationUserInvitations.vue?vue&type=template&id=15e7dd02&scoped=true&"
import script from "./OrganizationUserInvitations.vue?vue&type=script&lang=js&"
export * from "./OrganizationUserInvitations.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationUserInvitations.vue?vue&type=style&index=0&id=15e7dd02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e7dd02",
  null
  
)

export default component.exports